var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    _vm._l(_vm.migration.messages, function(message) {
      return _c(
        "div",
        {
          key: "msg-".concat(message.id),
          staticClass: "flex flex-column mb-5"
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [
                _c(
                  "span",
                  {
                    staticClass: "body-1 fw-bold"
                  },
                  [_vm._v(_vm._s(message.author))]
                ),
                _c(
                  "span",
                  {
                    staticClass: "body-1 fw-bold",
                    staticStyle: {
                      float: "right"
                    }
                  },
                  [_vm._v(_vm._s(message.date))]
                )
              ]),
              _c("gg-card-text", [
                _c("div", {
                  staticClass: "message-white-space",
                  domProps: {
                    innerHTML: _vm._s(_vm.sanitize(message.text))
                  }
                })
              ])
            ],
            1
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }